export default function (brand = "axter") {
    if (document.body.classList.contains(brand)) {
        return true;    
    } 
    return false;
}